import React from 'react';
import Helmet from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.css';
import "./layout.css";
import useSeo from '../hooks/use-seo';


const Layout = (props) => {

    const seo = useSeo();

    const { fallbackSeo: { description, title } } = seo;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
                <html lang="es" />
            </Helmet>
            {props.children}
        </>
    );
}
 
export default Layout;